import React from 'react';
import { connect } from 'react-redux';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { selectCurrentSalonCurrency, selectCurrentSalonCurrencySign } from 'selectors/currentSalon.selectors';
import fromComponentToName from 'utils/react/fromComponentToName.util';

const mapStateToProps = (state) => ({
  currentSalonAbbr: selectCurrentSalonCurrency(state),
  currentSalonSign: selectCurrentSalonCurrencySign(state),
});

const withSalonCurrency = (Component) => {
  // find out the name of the wrapped component or use a default one
  const displayName = `withSalonCurrency(${fromComponentToName(Component)})`;

  // create the wrapper component and use it to render the wrapped one
  const WithSalonCurrency = (props) => {
    const { forwardedRef, ...extra } = props;
    return <Component {...extra} ref={forwardedRef} />;
  };

  // static fields must be copied from the wrapped to the wrapper
  hoistNonReactStatics(WithSalonCurrency, Component);

  // nice display name for the wrapper
  WithSalonCurrency.displayName = displayName;

  // need to wire up few more wrappers for the extra props needed
  return connect(mapStateToProps)(React.forwardRef((props, ref) => <WithSalonCurrency {...props} forwardedRef={ref} />));
};

// noinspection JSUnusedGlobalSymbols
export default withSalonCurrency;
